export default function VersioningGuide() {
  return (
    <div>
      <h1>Versioning</h1>
      <p>
        The Chosen API is versioned in the URL path. Every endpoint lives under{' '}
        <code>/api/v1</code>.
      </p>

      <h2>What counts as breaking</h2>
      <p>The following are <em>breaking</em> and will only ship in a new major version:</p>
      <ul>
        <li>Removing an endpoint, parameter, or response field.</li>
        <li>Changing the type or shape of an existing field.</li>
        <li>Tightening validation rules on an existing parameter.</li>
        <li>Changing default values for optional parameters.</li>
        <li>Changing status codes for existing scenarios.</li>
      </ul>

      <h2>What is non-breaking</h2>
      <p>The following may ship in <code>v1</code> without notice:</p>
      <ul>
        <li>Adding new endpoints.</li>
        <li>Adding new optional parameters.</li>
        <li>Adding new fields to response bodies.</li>
        <li>Adding new response status codes for new edge cases.</li>
        <li>Performance and accuracy improvements.</li>
      </ul>

      <h2>Beta status</h2>
      <p>
        While the API is in <strong>beta</strong>, we reserve the right to make
        small breaking changes with at least 14 days' notice via{' '}
        <code>changelog@chosenhq.com</code>. Once we exit beta, the v1 contract
        will be frozen until we cut v2.
      </p>

      <h2>Deprecation policy</h2>
      <p>
        When we cut a new major version, the previous version will be supported
        for at least 12 months from the announcement date. Deprecated endpoints
        will return a <code>Deprecation</code> response header and a{' '}
        <code>Sunset</code> header indicating the last supported date.
      </p>
      <p>
        <em>
          Ask nicely and have a contract, and we'll usually extend that.
        </em>
      </p>
    </div>
  )
}
